import { Component } from '@angular/core';

@Component({
  selector: 'app-accordion-showcase',
  templateUrl: './accordion-showcase.component.html',
  styleUrls: ['./accordion-showcase.component.scss']
})
export class AccordionShowcaseComponent {

  faqItems = [
    {
      question: 'What is Cisco Steer?',
      answer: 'Cisco Steer is an incentive and rewards management platform designed for Cisco sellers and managers to track challenges, claims, and rewards.',
      open: false
    },
    {
      question: 'How do I submit a claim?',
      answer: 'Navigate to the Claims tab under your seller dashboard. Click "New Claim" and fill in the required details including deal information and supporting documents.',
      open: false
    },
    {
      question: 'When do rewards get processed?',
      answer: 'Rewards are typically processed within 30 business days after claim approval. You will receive a notification once your reward is ready for redemption.',
      open: false
    }
  ];
}
